module.exports = __webpack_public_path__ + "static/media/aside.0557dd81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aside.jpg
// module id = 284
// module chunks = 0